import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadingType from './loadingType';
export default class DotSpinner extends Component {
  static propTypes = {
    selectedLoading: PropTypes.string.isRequired,
    changeSelectedLoading: PropTypes.func.isRequired,
  };

  render() {
    const { selectedLoading, changeSelectedLoading } = this.props;
    const { key, value } = loadingType.DOT_SPINNER;
    return (
      <div
        className={`col-md-3 col-lg-3 col-xs-3 col-sm-3 text-center ${selectedLoading === key &&
          'border-2 border-success'}`}
      >
        <div className="card pt-3">
          <div className="drapcode-spinner-dot">
            <div className="dot1"></div>
            <div className="dot2"></div>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="radio"
                value={key}
                checked={selectedLoading === key}
                onChange={() => changeSelectedLoading(key)}
              />
              {value}
              <span className="circle">
                <span className="check"></span>
              </span>
            </label>
          </div>
        </div>
      </div>
    );
  }
}
